import Vue from "vue"
import VueRouter from "vue-router"

Vue.use(VueRouter)

const routes = [
  {
    path: "/",
    redirect: "/index",
  },
  {
    path: "/index",
    name: "index",
    component: () => import("../views/IndexView.vue"),
  },
  {
    path: "/informationSystem",
    name: "product",
    component: () => import("../views/InformationSystemView.vue"),
  },
  {
    path: "/informationSystem/informationId/:informationId",
    name: "informationDetails",
    component: () => import("../views/InformationDetailsView.vue"),
  },
  {
    path: "/product",
    name: "product",
    component: () => import("../views/ProductView.vue"),
  },
  {
    path: "/product/productId/:productId",
    name: "productDetails",
    component: () => import("../views/ProductDetailsView.vue"),
  },
  {
    path: "/example",
    name: "example",
    component: () => import("../views/ExampleView.vue"),
  },
  {
    path: "/news",
    name: "news",
    component: () => import("../views/NewsView.vue"),
  },
  {
    path: "/news/newsId/:newsId",
    name: "newsDetails",
    component: () => import("../views/NewsDetailsView.vue"),
  },
  {
    path: "/about",
    name: "about",
    component: () => import("../views/AboutView.vue"),
  },
  {
    path: "/submitForm",
    name: "submitForm",
    component: () => import("../views/SubmitFormView.vue"),
  },
  {
    path: "/clientList",
    name: "clientList",
    component: () => import("../views/ClientListView.vue")
  },
  {
    path: "/appDownload",
    name: "appDownload",
    component: () => import("../views/appDownload.vue")
  }
]

const router = new VueRouter({
  routes,
  // scrollBehavior (to, from, savedPosition) {
  //     if (savedPosition) {
  //       // 保存的滚动位置
  //       return savedPosition
  //     } else {
  //       // 滚动到页面顶部
  //       return { x: 0, y: 0 }
  //     }
  //   }
  scrollBehavior(to, from, savedPosition) {
    return {
        x: 0, 
        y: 0
    }
  },
})
export default router
